import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { RegistrationProvider } from '../services/registration.provider';
import { RegistrationFormProvider } from '../services/registration-form.provider';
import { Step1Component } from './step1/step1.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Step2Component } from './step2/step2.component';
import { ErrorDisplayerComponent } from './component/error-displayer/error-displayer.component';
import { VcinputComponent } from './component/vcinput/vcinput.component';
import { CompanyNameDomainSyncComponent } from './component/company-name-domain-sync/company-name-domain-sync.component';
import { SocialGoogleBtnComponent } from './component/social-google-btn/social-google-btn.component';
import { SocialFacebookBtnComponent } from './component/social-facebook-btn/social-facebook-btn.component';
import { VcselectComponent } from './component/vcselect/vcselect.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { Error500Component } from './component/error500/error500.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { RegisterComponent } from './register/register.component';
import { PasswordValidationTipsComponent } from './component/password-validation-tips/password-validation-tips.component';

const routes: Routes = [
  { path: 'registration', component: RegisterComponent },
  { path: 'registration/step1', pathMatch: 'full', redirectTo: 'registration' },
  { path: 'registration/step2', pathMatch: 'full', redirectTo: 'registration' }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule
  ],
  declarations: [
    RegisterComponent,
    Step1Component,
    Step2Component,
    PasswordValidationTipsComponent,
    ErrorDisplayerComponent,
    VcinputComponent,
    CompanyNameDomainSyncComponent,
    SocialGoogleBtnComponent,
    SocialFacebookBtnComponent,
    VcselectComponent,
    PageHeaderComponent,
    Error500Component,
    ThankyouComponent
  ],
  exports: [PageHeaderComponent],
  providers: [RegistrationProvider, RegistrationFormProvider]
})
export class RegistrationModule {}
